/**
 * Structured Data (JSON-LD) utilities for SEO
 * These help search engines understand the content better
 */

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'CadencePro.ai',
  url: 'https://cadencepro.ai',
  logo: 'https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/cadencepro_cover.jpeg',
  description: 'The AI Agent for Project Risk Management',
  sameAs: [
    'https://www.linkedin.com/company/cadencepro'
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'Customer Support',
    email: 'karan@cadencepro.ai',
  },
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'CadencePro.ai',
  url: 'https://cadencepro.ai',
  description: 'Equip yourself with an AI agent that runs real-time simulations, revealing how scope, resource, or schedule changes impact cost, delivery, and portfolio health.',
  publisher: {
    '@type': 'Organization',
    name: 'CadencePro.ai',
    logo: {
      '@type': 'ImageObject',
      url: 'https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/cadencepro_cover.jpeg',
    },
  },
};

export const softwareApplicationSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'CadencePro.ai',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'USD',
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.8',
    ratingCount: '127',
  },
  description: 'AI-powered project risk management and simulation platform that helps teams predict project outcomes and optimize resource allocation.',
};

export const breadcrumbSchema = (items: Array<{ name: string; url: string }>) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: `https://cadencepro.ai${item.url}`,
  })),
});

export const faqSchema = (faqs: Array<{ question: string; answer: string }>) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
});

export const contactPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'Contact Us',
  description: 'Get in touch with CadencePro.ai team',
  url: 'https://cadencepro.ai/contact',
  mainEntity: {
    '@type': 'Organization',
    name: 'CadencePro.ai',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Support',
      email: 'karan@cadencepro.ai',
    },
  },
};

export const videoObjectSchema = {
  '@context': 'https://schema.org',
  '@type': 'VideoObject',
  name: 'CadencePro.ai - AI Project Planning Agent Demo',
  description: 'See how Cadencepro manages project execution risk with AI-powered simulations. While PM tools manage tasks, Cadencepro manages project outcomes.',
  thumbnailUrl: 'https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/videoThumbnail.png',
  uploadDate: '2024-01-15T00:00:00Z',
  contentUrl: 'https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/documents/cadanceprovideo.mp4',
  embedUrl: 'https://cadencepro.ai',
  duration: 'PT2M30S', // Update this with actual video duration in ISO 8601 format (PT2M30S = 2 minutes 30 seconds)
};